import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'app-checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.scss'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CheckboxComponent),
            multi: true
        }],
    standalone: false
})
export class CheckboxComponent implements ControlValueAccessor {
    constructor() {
    }

    private _disabled: boolean;

    get disabled(): boolean | '' {
        return this._disabled;
    }

    @Input()
    set disabled(disabled: boolean | '') {
        this._disabled = disabled === '' || disabled;
    }

    private _checked: boolean;

    get checked(): boolean | '' {
        return this._checked;
    }

    @Input()
    set checked(checked: boolean | '') {
        this._checked = checked === '' || checked;
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onChange = (_: any): void => {
    };

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onBlur = (_: any): void => {
    };

    handleChange(event: any): void {
        if (!this.disabled) {
            this.checked = event && event.target && event.target.checked;
            this.onChange(this.checked);
        }
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onBlur = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    writeValue(value: any): void {
        this.checked = value;
    }

}
